import React from 'react'

function Rental() {
  return (
    <div>  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.003 5.8325H1.99805"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6682 9.16699C13.3258 9.16699 14.6695 10.5107 14.6695 12.1682C14.6695 13.8258 13.3258 15.1695 11.6682 15.1695C10.0107 15.1695 8.66699 13.8258 8.66699 12.1682C8.66699 10.5107 10.0107 9.16699 11.6682 9.16699"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.78329 14.503H3.99888C2.89385 14.503 1.99805 13.6072 1.99805 12.5022V4.49888C1.99805 3.39385 2.89385 2.49805 3.99888 2.49805H12.0022C13.1072 2.49805 14.003 3.39385 14.003 4.49888V10.2833"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.8169 10.6943V12.2893"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5176 12.2895H11.8167"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.53186 8.16648C4.53186 8.1849 4.51693 8.19983 4.49851 8.19983C4.48009 8.19983 4.46516 8.1849 4.46516 8.16648C4.46516 8.14806 4.48009 8.13313 4.49851 8.13313"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.49844 8.1332C4.51686 8.1332 4.53179 8.14813 4.53179 8.16655"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.86682 8.16648C6.86682 8.1849 6.85189 8.19983 6.83347 8.19983C6.81506 8.19983 6.80013 8.1849 6.80013 8.16648C6.80013 8.14806 6.81506 8.13313 6.83347 8.13313"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.8334 8.1332C6.85182 8.1332 6.86675 8.14813 6.86675 8.16655"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.53186 10.1675C4.53186 10.1859 4.51693 10.2008 4.49851 10.2008C4.48009 10.2008 4.46516 10.1859 4.46516 10.1675C4.46516 10.149 4.48009 10.1341 4.49851 10.1341"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.49844 10.1342C4.51686 10.1342 4.53179 10.1491 4.53179 10.1675"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.86682 10.1675C6.86682 10.1859 6.85189 10.2008 6.83347 10.2008C6.81506 10.2008 6.80013 10.1859 6.80013 10.1675C6.80013 10.149 6.81506 10.1341 6.83347 10.1341"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.8334 10.1342C6.85182 10.1342 6.86675 10.1491 6.86675 10.1675"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.19983 8.16648C9.19983 8.1849 9.1849 8.19983 9.16648 8.19983C9.14806 8.19983 9.13313 8.1849 9.13313 8.16648C9.13313 8.14806 9.14806 8.13313 9.16648 8.13313"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.16641 8.1332C9.18483 8.1332 9.19976 8.14813 9.19976 8.16655"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.53186 12.1684C4.53186 12.1869 4.51693 12.2018 4.49851 12.2018C4.48009 12.2018 4.46516 12.1869 4.46516 12.1684C4.46516 12.15 4.48009 12.1351 4.49851 12.1351"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.49844 12.1352C4.51686 12.1352 4.53179 12.1501 4.53179 12.1685"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.86682 12.1684C6.86682 12.1869 6.85189 12.2018 6.83347 12.2018C6.81506 12.2018 6.80013 12.1869 6.80013 12.1684C6.80013 12.15 6.81506 12.1351 6.83347 12.1351"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.8334 12.1352C6.85182 12.1352 6.86675 12.1501 6.86675 12.1685"
      stroke="#959595"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Rental